module.exports = __webpack_public_path__ + "img/welcome.24960e06.jpg";